import Konva from "konva";
import React from "react";
import { Group } from "react-konva";
import { SpotGhostItem } from "../../SpotGhostItem";
import { SvgGhostItem } from "../../SvgGhostItem";
import { useMapEditorTool } from "../../contexts/MapEditorContext";

export interface MapCanvasGhostLayersProps {
  isMouseIn: boolean;
  iconToolGhostRef: React.RefObject<Konva.Group | null>;
}

export const MapCanvasGhostLayers: React.FC<MapCanvasGhostLayersProps> = ({
  isMouseIn,
  iconToolGhostRef
}) => {
  const { iconToolSelectedIcon, furnitureToolSelectedFurniture, activeTool } =
    useMapEditorTool();

  if (!isMouseIn) return;

  return (
    <Group opacity={0.5}>
      {iconToolSelectedIcon && activeTool === "icon" && (
        <SvgGhostItem
          icon={iconToolSelectedIcon}
          ref={iconToolGhostRef as never}
        />
      )}
      {furnitureToolSelectedFurniture && activeTool === "furniture" && (
        <SvgGhostItem
          furniture={furnitureToolSelectedFurniture}
          ref={iconToolGhostRef as never}
        />
      )}
      {activeTool === "spot" && <SpotGhostItem ref={iconToolGhostRef} />}
    </Group>
  );
};
